import { Builder } from '@builder.io/sdk';
import { S9PressReleaseSection } from '../components/interactive-sections/S9PressRelease';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import {
  backgroundColorOptions,
  backgroundGradientOptions,
  textColorOptionsLimited,
  waveColorOptions,
} from '../utils/builderColorOptions';
import { getBackgroundGradientInput, getPaddingInputs, getBackgroundColorInput } from '../utils/builderSharedInputs';

Builder.registerComponent(S9PressReleaseSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S9PressRelease,
  friendlyName: 'S9 Press Release',
  inputs: [
    {
      name: 'title',
      type: 'string',
      friendlyName: 'Title',
      required: true,
      defaultValue: 'Press Releases',
      helperText: 'The main heading displayed at the top of the press release section'
    },
    {
      name: 'titleColor',
      type: 'string',
      friendlyName: 'Title Color',
      enum: textColorOptionsLimited,
      defaultValue: 'Blue',
      helperText: 'Select a color for the title text'
    },
    {
      name: 'cards',
      friendlyName: 'Press Release Cards',
      type: 'list',
      required: true,
      onChange: (options) => {
        // check if the list has less than 4 cards
        if (options.get('cards').length < 4) {
          alert('minimum items are 4, add items to continue')
        }
      },
      defaultValue: [
        {
          title: 'Milan Laser Hair Removal Announces New Location Opening',
          pressReleaseDate: '2024-01-15',
          href: '/press/milan-laser-new-location-opening'
        },
        {
          title: 'Milan Laser Expands Services to Include Advanced Treatment Options',
          pressReleaseDate: '2024-01-10',
          href: '/press/milan-laser-expands-services'
        },
        {
          title: 'Milan Laser Receives Industry Recognition for Excellence',
          pressReleaseDate: '2024-01-05',
          href: '/press/milan-laser-industry-recognition'
        },
        {
          title: 'Milan Laser Achieves New Industry Milestone',
          pressReleaseDate: '2024-01-01',
          href: '/press/milan-laser-industry-milestone'
        }
      ],
      helperText: 'Add press release cards with titles and dates (minimum: 4)',
      subFields: [
        {
          name: 'title',
          type: 'string',
          friendlyName: 'Press Release Title',
          required: true,
          helperText: 'Enter the title of the press release'
        },
        {
          name: 'pressReleaseDate',
          type: 'date',
          friendlyName: 'Press Release Date',
          required: true,
          helperText: 'Select the date of the press release'
        },
        {
          name: 'href',
          type: 'string',
          friendlyName: 'Press Release Link',
          required: true,
          helperText: 'Enter the URL or path where this press release card should link to'
        }
      ]
    },
    {
      name: 'cardBackgroundColor',
      type: 'string',
      friendlyName: 'Card Background Color',
      enum: backgroundColorOptions,
      defaultValue: 'TrueWhite',
      helperText: 'Select the background color for press release cards. Select None if a card background gradient is selected.'
    },
    {
      name: 'cardBackgroundGradient',
      type: 'string',
      friendlyName: 'Card Background Gradient',
      enum: backgroundGradientOptions,
      defaultValue: 'None',
      helperText: 'Select a gradient for the press release card backgrounds. Select None if a card background color is selected.'
    },
    {
      name: 'cardBackgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      friendlyName: 'Card Background Image',
      helperText: 'Upload an image to use as the press release card background'
    },
    {
      name: 'cardTitleColor',
      type: 'string',
      friendlyName: 'Card Title Color',
      enum: textColorOptionsLimited,
      defaultValue: 'Turquoise',
      helperText: 'Select a color for the press release card titles'
    },
    {
      name: 'cardLinkColor',
      type: 'string',
      friendlyName: 'Card Link Color',
      enum: textColorOptionsLimited,
      defaultValue: 'Navy',
      helperText: 'Select a color for the press release card links'
    },
    {
      name: 'backgroundWave',
      type: 'boolean',
      friendlyName: 'Show Background Wave',
      defaultValue: true,
      helperText: 'Toggle to show or hide the background wave. This will not work if background gradient is selected.'
    },
    {
      name: 'flipWave',
      type: 'boolean',
      friendlyName: 'Flip Background Wave',
      defaultValue: false,
      helperText: 'Toggle to flip the background wave direction'
    },
    {
      name: 'backgroundWaveColor',
      type: 'string',
      friendlyName: 'Background Wave Color',
      enum: waveColorOptions,
      defaultValue: 'White',
      helperText: 'Select the color for the background wave'
    },
    ...getBackgroundColorInput({
      defaultValue: 'Blue10',
      helperText: 'Solid background color. Set Background Gradient to None if using this.'
    }),
    ...getBackgroundGradientInput({
      backgroundGradientList: backgroundGradientOptions,
      helperText: 'Background gradient. Set Background Color to None if using this.'
    }),
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      friendlyName: 'Background Image',
      helperText: 'Upload an image to use as the section background'
    },
    ...getPaddingInputs({
      desktopTop: "large",
      desktopBottom: "large",
      mobileTop: "small",
      mobileBottom: "small"
    }),
  ]
});
